import { useState } from 'react';
import Icon from '@components/common/Icon';
import { SOCIAL_LINKS } from '@lib/constants';

const ContactInfoSection = () => {
  const [showEmailModal, setShowEmailModal] = useState(false);
  const [copied, setCopied] = useState(false);

  const handleCopyEmail = () => {
    navigator.clipboard.writeText(SOCIAL_LINKS.email);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  const contactMethods = [
    {
      icon: 'email',
      label: 'Email',
      value: SOCIAL_LINKS.email,
      href: null,
      onClick: () => setShowEmailModal(true),
      description: 'Send me an email anytime',
    },
    {
      icon: 'phone',
      label: 'Phone',
      value: SOCIAL_LINKS.phone,
      href: `tel:${SOCIAL_LINKS.phone}`,
      description: 'Call or text me',
    },
    {
      icon: 'github',
      label: 'GitHub',
      value: '@Sri-SriPod',
      href: SOCIAL_LINKS.github,
      description: 'Check out my code',
    },
    {
      icon: 'linkedin',
      label: 'LinkedIn',
      value: 'Connect with me',
      href: SOCIAL_LINKS.linkedin,
      description: 'Professional network',
      disabled: SOCIAL_LINKS.linkedin === '#',
    },
    {
      icon: 'lichess',
      label: 'Lichess',
      value: 'Challenge me',
      href: SOCIAL_LINKS.lichess,
      description: 'Play chess online',
      disabled: SOCIAL_LINKS.lichess === '#',
    },
  ];

  return (
    <section
      className="py-16 px-6"
      style={{ backgroundColor: 'var(--color-body-bg)' }}
    >
      <div className="max-w-6xl mx-auto">
        <h2
          className="text-3xl md:text-4xl font-bold text-center mb-12"
          style={{ color: 'var(--color-heading)' }}
        >
          Contact Methods
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {contactMethods.map((method) => {
            const Element = method.onClick ? 'button' : 'a';
            return (
              <Element
                key={method.label}
                href={!method.onClick && !method.disabled ? method.href : undefined}
                target={method.href?.startsWith('http') ? '_blank' : undefined}
                rel={method.href?.startsWith('http') ? 'noopener noreferrer' : undefined}
                onClick={method.onClick || ((e) => {
                  if (method.disabled) {
                    e.preventDefault();
                  }
                })}
                className={`p-6 rounded-xl border-2 transition-all duration-300 w-full text-left ${
                  method.disabled
                    ? 'opacity-50 cursor-not-allowed'
                    : 'hover:scale-105'
                }`}
                style={{
                  backgroundColor: 'var(--color-card-bg)',
                  borderColor: method.disabled
                    ? 'var(--color-border-light)'
                    : 'var(--color-card-border)',
                  color: 'var(--color-card-text)',
                }}
              >
              <div className="flex items-start gap-4">
                <div
                  className="p-3 rounded-lg"
                  style={{ backgroundColor: 'var(--color-accent-1)' }}
                >
                  <Icon
                    name={method.icon}
                    size="xl"
                    style={{ color: 'var(--color-accent-7)' }}
                  />
                </div>
                <div className="flex-1">
                  <h3
                    className="text-xl font-semibold mb-1"
                    style={{ color: 'var(--color-heading)' }}
                  >
                    {method.label}
                  </h3>
                  <p
                    className="text-sm mb-2"
                    style={{ color: 'var(--color-muted)' }}
                  >
                    {method.description}
                  </p>
                  <p
                    className="font-medium break-all"
                    style={{ color: 'var(--color-accent-6)' }}
                  >
                    {method.value}
                  </p>
                </div>
              </div>
              </Element>
            );
          })}
        </div>
      </div>

      {/* Email Modal */}
      {showEmailModal && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center p-4"
          style={{ backgroundColor: 'rgba(0, 0, 0, 0.5)' }}
          onClick={() => setShowEmailModal(false)}
        >
          <div
            className="rounded-lg shadow-2xl p-6 max-w-md w-full"
            style={{
              backgroundColor: 'var(--color-card-bg)',
              borderColor: 'var(--color-card-border)',
              borderWidth: '1px'
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <h3
              className="text-xl font-heading font-bold mb-4"
              style={{ color: 'var(--color-heading)' }}
            >
              Email Address
            </h3>
            <div
              className="p-4 rounded-lg mb-4 font-mono text-center"
              style={{
                backgroundColor: 'var(--color-theme-3)',
                color: 'var(--color-body-text)'
              }}
            >
              {SOCIAL_LINKS.email}
            </div>
            <div className="flex gap-3">
              <button
                onClick={handleCopyEmail}
                className="flex-1 px-4 py-2 rounded-lg font-medium transition-all duration-200"
                style={{
                  backgroundColor: copied ? 'var(--color-accent-6)' : 'var(--color-button-primary-bg)',
                  color: 'var(--color-button-primary-text)'
                }}
              >
                {copied ? '✓ Copied!' : 'Copy Email'}
              </button>
              <button
                onClick={() => setShowEmailModal(false)}
                className="flex-1 px-4 py-2 rounded-lg font-medium transition-all duration-200"
                style={{
                  borderColor: 'var(--color-button-outline-border)',
                  color: 'var(--color-button-outline-text)',
                  borderWidth: '1.5px',
                  borderStyle: 'solid',
                  backgroundColor: 'transparent'
                }}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default ContactInfoSection;
